module.exports = "https://cdn.realtymogul.com/static/media/Bill_M.de6fddb8.jpg";